import React, { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"
// Components
import Navbar from "../../components/Navbar/Navbar"
import Footer from "../../components/Footer/Footer"
// Data
import { publicRequest } from "../../requestMethods"
// Styles
import { Container, Wrapper, Label, Error } from "./Verify.styles"

const Verify = () => {
   const navigate = useNavigate()
   const { t } = useTranslation()
   const { userId } = useParams()
   const [error, setError] = useState("")
   const [isActive, setIsActive] = useState(false)

   useEffect(() => {
      const verifyUser = async () => {
         try {
            await publicRequest.post("/auth/verify", { userId })
            setIsActive(true)
         } catch (err) {
            setError(err)
         }
      }
      verifyUser()
   }, [userId])

   useEffect(() => {
      isActive && setTimeout(() => navigate("/login"), 4000)
   }, [isActive, navigate])

   return (
      <>
         <Helmet>
            <title>{t("accountPage.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Navbar bgImageColor="light" />
            <Wrapper>
               {isActive && <Label>{t("verifyPage.label.l1")}</Label>}
               {error && <Error>{error.message}</Error>}
            </Wrapper>
            <Footer />
         </Container>
      </>
   )
}

export default Verify
